import { render, staticRenderFns } from "./ConfirmCheckbox.vue?vue&type=template&id=884dc272"
import script from "./ConfirmCheckbox.vue?vue&type=script&lang=ts"
export * from "./ConfirmCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmCheckbox.vue?vue&type=style&index=0&id=884dc272&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports